import { useSelector } from 'react-redux';
import { ExareSeatReleaseMode, InsuranceType } from '@websky/graphql';
import { getIsAnySeatsToRefund, getIsNasServiceRefundRequired, getRefundAutoMode, getSeatReleaseMode } from '../model';
import { getSelectedVskInsurancesByType } from '../../../../Checkout/store/order/selectors';
import { useHasPaidInsurances } from '@entities/order';

export const useCreateRefundNotifications = () => {
	const isAutoMode = useSelector(getRefundAutoMode);
	const seatReleaseMode = useSelector(getSeatReleaseMode);
	const isAnySeatsToRefund = useSelector(getIsAnySeatsToRefund);
	const isNasServiceRefundRequired = useSelector(getIsNasServiceRefundRequired);
	const selectedVskInsurances = useSelector(getSelectedVskInsurancesByType);

	const showInsuranceAlphaOrSirenaMessage = useHasPaidInsurances([
		InsuranceType.AlphaInsurance,
		InsuranceType.SirenaInsurance
	]);

	const showCaculationMessage = !isAutoMode;
	const isExareSeatReleaseOff = seatReleaseMode === ExareSeatReleaseMode.Off;
	const showRefundSeatsMessage = !isExareSeatReleaseOff && isAnySeatsToRefund;
	const showNasService = isNasServiceRefundRequired;
	const showVskMessage = !isNasServiceRefundRequired && !!selectedVskInsurances.length;

	const showNotifications = [
		showCaculationMessage,
		showRefundSeatsMessage,
		showNasService,
		showVskMessage,
		showInsuranceAlphaOrSirenaMessage
	].some(notification => notification);

	return {
		showNotifications,
		notifications: {
			showCaculationMessage,
			showRefundSeatsMessage,
			showNasService,
			showVskMessage,
			showInsuranceAlphaOrSirenaMessage
		}
	};
};
